module.exports = "/images/tag_a13582.png";